import React, { useEffect } from 'react';
import DENTModalOverviewPeriodontalSelectMapBox from './DENTModalOverviewPeriodontalSelectMapBox';
import {
	DEPTH_VALUES,
	MARGIN_VALUES_NEGATIVE,
	MARGIN_VALUES_POSITIVE,
} from './MapValues';
import styles from './DENTModalOverviewPeriodontalSelectMap.module.scss';
import { useDENTContext } from '../../Services/DENTContext';
import useToothPeriodontal from '../../Hooks/Tooth/Periodontal/useToothPeriodontal';
import { OverviewMode } from '../../Enums/OverviewMode.enum';
import { joinClasses } from '../../../../Utils/className.util';

const MAXIMUM_VALUE = 13;

const getDefaultMarginValues = (margin: number) => {
	return margin < 0 ? MARGIN_VALUES_NEGATIVE : MARGIN_VALUES_POSITIVE;
};

const DENTModalOverviewPeriodontalSelectMap = () => {
	const { activePeriodontalItem, overviewMode } = useDENTContext();
	const { periodontal } = useToothPeriodontal();

	const depth = periodontal.getPeriodontal[activePeriodontalItem].depth;
	const margin = periodontal.getPeriodontal[activePeriodontalItem].margin;

	const [hiddenDepthValues, setHiddenDepthValues] = React.useState<number[]>(
		[],
	);
	const [marginValues, setMarginValues] = React.useState<
		Record<string, number>
	>(getDefaultMarginValues(margin));

	useEffect(() => {
		const maximumPossibleDepth =
			margin >= 0 ? MAXIMUM_VALUE : MAXIMUM_VALUE + margin;
		const newHiddenDepthValues = Object.values(DEPTH_VALUES).filter(
			value => value > maximumPossibleDepth,
		);

		setHiddenDepthValues(newHiddenDepthValues);
	}, [depth, margin]);

	const handleSwitchMarginValues = () => {
		const isPositive = '1' in marginValues;
		setMarginValues(
			isPositive ? MARGIN_VALUES_NEGATIVE : MARGIN_VALUES_POSITIVE,
		);
	};

	return (
		<div
			className={joinClasses([
				styles.wrapper,
				overviewMode === OverviewMode.PERIODONTAL
					? styles.quickAdjustmentWrapper
					: '',
			])}>
			<DENTModalOverviewPeriodontalSelectMapBox
				title={
					'patientTreatment.meddiDENT.dentalCross.periodontal.probingDepth'
				}
				values={DEPTH_VALUES}
				hiddenValues={hiddenDepthValues}
				selectedValue={depth}
				setValue={periodontal[activePeriodontalItem].setDepth}
			/>
			<DENTModalOverviewPeriodontalSelectMapBox
				title={
					'patientTreatment.meddiDENT.dentalCross.periodontal.gingivalMargin'
				}
				values={marginValues}
				selectedValue={margin}
				setValue={periodontal[activePeriodontalItem].setMargin}
				onChangeValues={handleSwitchMarginValues}
			/>
		</div>
	);
};

export default DENTModalOverviewPeriodontalSelectMap;
